class ControlInstance {
  constructor(sendMessage) {
    this.sendMessage = sendMessage;
  }
}
class DefaultControlInstance extends ControlInstance {
  recv(_message) {
  }
  child(_key) {
    return void 0;
  }
}
export {
  ControlInstance,
  DefaultControlInstance
};
//# sourceMappingURL=instance.js.map